import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'jalali-moment';
@Pipe({
  name: 'jalali'
})
export class JalaliPipe implements PipeTransform {

  transform(value: unknown, format: string): unknown {
    let dateFormat = 'YYYY/MM/DD';
    if (format !== undefined) {
      dateFormat = format;
    }
   return  moment(value, 'jYYYYjMMjDD').format("jYYYY/jMM/jDD").toString();
    // return moment(value).locale('fa').format(dateFormat);

  }

}
